<div
  *ngIf="control"
  class="form-group mat-combobox"
  [class.required]="isRequired"
  [class.disabled]="isDisabled"
  [formGroup]="parentForm"
>
  <mat-label *ngIf="title" class="pr-2">{{ title }}</mat-label>
  <br />
  <mat-radio-group (change)="change()" [formControlName]="formControlName">
    <mat-radio-button
      *ngFor="let item of collection; let i = index"
      value="{{ item[keyPropertyName] || item }}"
      [class.selected-item]="isSelected(item[keyPropertyName] || item)"
    >
      {{ item[valuePropertyName] || item }}
    </mat-radio-button>
  </mat-radio-group>
  <!-- errors: {{ control.errors | json }} -->
  <span
    class="success-mark"
    *ngIf="control.value && !control.errors && !control.hideSuccessMark && !control.errors?.incorrect"
  >
    <fa-icon [icon]="faCheck"></fa-icon>
  </span>
</div>
